module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "120px"
    }
  }, [_vm._l((_vm.options.items), function(item, index) {
    return _c('el-form-item', {
      key: index,
      attrs: {
        "label": item.label
      }
    }, [(typeof item.description === 'undefined') ? _c('el-input', {
      attrs: {
        "autosize": {
          minRows: 2,
          maxRows: 16
        },
        "type": item.type || 'text'
      },
      model: {
        value: (_vm.form[item.prop]),
        callback: function($$v) {
          _vm.$set(_vm.form, item.prop, $$v)
        },
        expression: "form[item.prop]"
      }
    }) : _vm._e(), _vm._v(" "), (typeof item.description !== 'undefined') ? _c('el-popover', {
      attrs: {
        "placement": "right-start",
        "title": item.label,
        "width": "50%",
        "trigger": "hover",
        "content": item.description
      }
    }, [_c('el-input', {
      attrs: {
        "slot": "reference",
        "autosize": {
          minRows: 2,
          maxRows: 16
        },
        "type": item.type || 'text'
      },
      slot: "reference",
      model: {
        value: (_vm.form[item.prop]),
        callback: function($$v) {
          _vm.$set(_vm.form, item.prop, $$v)
        },
        expression: "form[item.prop]"
      }
    })], 1) : _vm._e()], 1)
  }), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.onSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-4f050399","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/containers/Create.vue
// module id = ml9b
// module chunks = 1